/* eslint-disable import/prefer-default-export */
import { ref } from 'vue';

import { useStyle } from '@composables/use-style';
import { StyleExtensionFunctionType } from '@v1/composables/sfc-types';

export const useStyleExtension: StyleExtensionFunctionType = (extension) => {
  const { colors, fontStyle } = useStyle();

  return ref({
    container: {
      color: colors.PRIMARY3(),
      fontFamily: fontStyle.FAMILY.PRIMARY,
      maxWidth: '100%',
      width: 'fit-content',
      ...extension.container,
    },
  });
};
